export default function isPayload(payload) {
  return payload && 'adobeMappedData' in payload && 'traceId' in payload;
}